/* eslint-disable no-unused-vars */
// TODO: remove later
import * as thunks from './thunks';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetPOReportsPayload,
  PurchaseOrderListItem,
  PurchaseOrderParams,
  PurchaseOrderReport
} from './types';
import { PaginationV2 } from 'src/types';

type State = {
  poReports: PurchaseOrderReport[];
  purchaseOrders: PurchaseOrderListItem[];
  selectedPurchaseOrders: PurchaseOrderListItem[]; // for multi Select purchase orders
  isPurchaseOrdersLoading: boolean;
  isReportsLoading: boolean;
  isShowList: boolean;
  meta: PaginationV2;
  totalAmount?: number | null;
  params: PurchaseOrderParams;
  reportsMeta: PaginationV2;
  reportsParams: GetPOReportsPayload;
};

const initialState: State = {
  isPurchaseOrdersLoading: false,
  isReportsLoading: false,
  isShowList: false,
  purchaseOrders: [],
  poReports: [],
  selectedPurchaseOrders: [],
  meta: {
    current_page: 1
  },
  params: {},
  totalAmount: null,
  reportsMeta: {
    current_page: 1
  },
  reportsParams: {}
};

const filterParamsAction = (
  state: State,
  { payload }: PayloadAction<PurchaseOrderParams>
) => {
  state.params = { ...payload };
};

const setReportsParams = (
  state: State,
  { payload }: PayloadAction<GetPOReportsPayload>
) => {
  state.reportsParams = payload;
};

const setSelectedPurchaseOrder = (
  state: State,
  { payload }: PayloadAction<PurchaseOrderListItem[]>
) => {
  state.selectedPurchaseOrders = payload;
};

const clearSelectedPurchaseOrder = (state: State) => {
  state.selectedPurchaseOrders = [];
};

const slice = createSlice({
  name: 'puchase-order',
  initialState,
  reducers: {
    filterParamsAction,
    setSelectedPurchaseOrder,
    clearSelectedPurchaseOrder,
    setReportsParams
  },
  extraReducers(builder) {
    builder.addCase(thunks.getPurchaseOrdersThunk.pending, (state) => {
      state.isPurchaseOrdersLoading = true;
    });
    builder.addCase(
      thunks.getPurchaseOrdersThunk.fulfilled,
      (state, { payload }) => {
        state.purchaseOrders = payload?.originalData?.data || [];
        state.meta = payload?.originalData?.meta || {};
        state.isPurchaseOrdersLoading = false;
        state.isShowList = true;
      }
    );

    builder.addCase(thunks.getPurchaseOrdersThunk.rejected, (state) => {
      state.isPurchaseOrdersLoading = false;
    });

    // PO Report add cases
    builder.addCase(thunks.getReportsThunk.pending, (state) => {
      state.isReportsLoading = true;
    });

    builder.addCase(thunks.getReportsThunk.fulfilled, (state, { payload }) => {
      state.isReportsLoading = false;
      state.poReports = payload?.originalData?.data || [];
      state.reportsMeta = payload?.originalData?.meta || {};
      state.isShowList = true;
    });

    builder.addCase(thunks.getReportsThunk.rejected, (state) => {
      state.isReportsLoading = false;
    });

    builder.addCase(
      thunks.getPurchaseOrderComputationThunk.pending,
      (state) => {
        state.isPurchaseOrdersLoading = true;
        state.isShowList = false;
      }
    );
    builder.addCase(
      thunks.getPurchaseOrderComputationThunk.fulfilled,
      (state, { payload }) => {
        state.totalAmount = payload?.originalData?.total_amount;
        state.isPurchaseOrdersLoading = false;
      }
    );

    builder.addCase(
      thunks.getPurchaseOrderComputationThunk.rejected,
      (state) => {
        state.isPurchaseOrdersLoading = false;
      }
    );
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...thunks,
  ...slice.actions
};
